import * as tslib_1 from "tslib";
var DurationFormat = (function () {
    function DurationFormat() {
    }
    return DurationFormat;
}());
export { DurationFormat };
var SECOND = 1000;
var MINUTE = 60 * SECOND;
var HOUR = 60 * MINUTE;
var DAY = 24 * HOUR;
var WEEK = 7 * DAY;
var HMSDurationFormat = (function (_super) {
    tslib_1.__extends(HMSDurationFormat, _super);
    function HMSDurationFormat(units) {
        if (units === void 0) { units = ''; }
        var _this = _super.call(this) || this;
        _this.units = units;
        return _this;
    }
    HMSDurationFormat.prototype.format = function (millis) {
        if (isFinite(millis)) {
            var weeks = void 0;
            if (millis > WEEK) {
                weeks = Math.floor(millis / WEEK);
                millis %= WEEK;
            }
            var days = void 0;
            if (millis > DAY) {
                days = Math.floor(millis / DAY);
                millis %= DAY;
            }
            var hours = void 0;
            if (millis > HOUR) {
                hours = Math.floor(millis / HOUR);
                millis %= HOUR;
            }
            var minutes = void 0;
            if (millis > MINUTE) {
                minutes = Math.floor(millis / MINUTE);
                millis %= MINUTE;
            }
            var seconds = void 0;
            if (millis > SECOND) {
                seconds = Math.floor(millis / SECOND);
                millis %= SECOND;
            }
            var s = '';
            if (weeks) {
                s += weeks + 'w';
            }
            if (days) {
                s += days + 'd';
            }
            if (hours) {
                s += hours + 'h';
            }
            if (minutes) {
                s += minutes + 'm';
            }
            if (seconds || !s) {
                s += (seconds || 0) + 's';
            }
            s += this.units;
            return s;
        }
        else {
            return '' + millis;
        }
    };
    return HMSDurationFormat;
}(DurationFormat));
export { HMSDurationFormat };
//# sourceMappingURL=data:application/json;base64,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